import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "contents-sub-title-text brg-color-grey-800"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["src"];
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Select',
    props: {
        width: { default: 0 },
        value: { default: '' },
        title: { default: '' },
        items: { default: () => [] },
        onChange: { type: Function, default: () => { } }
    },
    setup(__props) {
        const compProps = __props;
        const isImgIconExist = (item) => !!item?.imgIcon;
        /**
         * 선택 이벤트 핸들러
         */
        const handleChange = (newValue) => {
            compProps.onChange(newValue);
        };
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createElementBlock("div", {
                class: "brg-input-section select-wrapper",
                style: _normalizeStyle(_ctx.width > 0 ? `width: ${_ctx.width}px !important` : '')
            }, [
                (_ctx.title)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    "model-value": _ctx.value,
                    items: _ctx.items,
                    "hide-details": "",
                    flat: "",
                    variant: "outlined",
                    density: "compact",
                    "bg-color": "white",
                    "menu-props": {
                        contentClass: 'brg-select-option',
                    },
                    class: _normalizeClass(_ctx.title ? 'mt-1' : ''),
                    "onUpdate:modelValue": handleChange
                }, {
                    selection: _withCtx(({ item }) => [
                        (isImgIconExist(item.raw))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                _createElementVNode("img", {
                                    src: `/svg/use-yn-${item.raw.imgIcon}.svg`,
                                    class: "mr-2"
                                }, null, 8 /* PROPS */, _hoisted_3)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(item.raw.text), 1 /* TEXT */)
                    ]),
                    item: _withCtx(({ props, item }) => [
                        _createElementVNode("div", _mergeProps(props, { class: "cy-select-option pa-4" }), [
                            (isImgIconExist(item.raw))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                    _createElementVNode("img", {
                                        class: "mr-2",
                                        src: `/svg/use-yn-${item.raw.imgIcon}.svg`,
                                        alt: "item.raw"
                                    }, null, 8 /* PROPS */, _hoisted_5)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                        ], 16 /* FULL_PROPS */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model-value", "items", "class"])
            ], 4 /* STYLE */));
        };
    }
});
